module.exports = __webpack_public_path__ + "img/01-tittle-01.775a773b.png";